// import React from "react";
import {useState} from 'react';
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import Login from "./components/pages/Login";
import Property from "./components/pages/Property";
import Purchase from "./components/pages/Purchase";
import Project from "./components/pages/Project";

function App() {

  /**
   * スプラッシュ画面が消えるまでの時間
   */
  const SPLASH_DISAPPEAR_TIME=1000;

  /**
   * スプラッシュ画面を表示しているかどうか
   */
  const [isSplashShow, splashDisapper] = useState<boolean>(true)

  /**
   * 定義された時間後、スプラッシュ画面を消す
   */
  setTimeout(()=>{
    splashDisapper(false)
  },SPLASH_DISAPPEAR_TIME)

  //CSSの変数'--vh'の設定
  // 最初に、ビューポートの高さを取得し、0.01を掛けて1%の値を算出して、vh単位の値を取得
  let vh = window.innerHeight * 0.01;
  // カスタム変数--vhの値をドキュメントのルートに設定
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  // resizeイベントの取得
  window.addEventListener('resize', () => {
    // あとは上記と同じスクリプトを実行
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });


  return (
    <div className="main">
      <div className="main__inner">
        { isSplashShow&&
          (
            <div className="splash content">
            <div className="splash__inner content__inner">
              <div className="loading-animation splash__loading-animation">
                <div className="loading-animation__inner">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
              </div>
            </div>
          </div>
        </div>
          )
        }
        <BrowserRouter basename="/sp/">
          <Switch>
            <Route path="/login" exact component={Login} />
            <Route path="/property" exact component={Property} />
            <Route path="/purchase" exact component={Purchase} />
            <Route path="/project" exact component={Project} />
            <Redirect to="/login" />
          </Switch>
        </BrowserRouter>
      </div>
    </div>
  );
}
export default App;